import { syncTranslationWithStore, I18n } from 'react-redux-i18n';
import moment from 'moment';
import forEach from 'lodash/forEach';
import get from 'lodash/get';
import { setupI18n } from '@peoplenet/vi-components-ui/src/I18n';
import storeProvider from '@peoplenet/vi-components-ui/src/store';
import en from '@peoplenet/vi-components-ui/src/app/translation/languages/en.yml';
import pt from '@peoplenet/vi-components-ui/src/app/translation/languages/pt.yml';
import pl from '@peoplenet/vi-components-ui/src/app/translation/languages/pl.yml';
import nl from '@peoplenet/vi-components-ui/src/app/translation/languages/nl.yml';
import fr from '@peoplenet/vi-components-ui/src/app/translation/languages/fr.yml';
import de from '@peoplenet/vi-components-ui/src/app/translation/languages/de.yml';
import es from '@peoplenet/vi-components-ui/src/app/translation/languages/es.yml';
import it from '@peoplenet/vi-components-ui/src/app/translation/languages/it.yml';

I18n.setHandleMissingTranslation((text, repl) => {
  if (repl.length > 0) return repl;
  if (text && text.length > 0) return text.split('.').pop();
  return null;
});

export const availableLanguages = [
  'en-us',
  'pt-br',
  'pt-BR',
  'pl',
  'nl',
  'fr',
  'de',
  'es',
  'it',
];

const availableTranslations = {
  en,
  pt,
  pl,
  nl,
  fr,
  de,
  es,
  it,
};

forEach(availableTranslations, (translation, language) => {
  const localeConfig = {
    relativeTime: get(translation, 'configuration.relativeTime'),
  };

  moment.defineLocale(language, localeConfig);

  const locale = get(translation, 'configuration.location');

  if (locale && locale !== language) {
    moment.defineLocale(locale, localeConfig);
  }
});

export const setupTranslation = (_language) => {
  const store = storeProvider.getStore();
  const geotabDefaultLanguage = _language;
  const defaultLanguage = availableLanguages.includes(geotabDefaultLanguage)
    ? geotabDefaultLanguage
    : 'en-us';

  let language = defaultLanguage.toLowerCase();

  if (language.indexOf('-') > -1) {
    [language] = language.split(/[_-]+/);
  }

  const locale = get(
    availableTranslations,
    `${language}.configuration.location`,
    language,
  );
  moment.locale(locale);

  setupI18n(
    {
      store,
      language,
      translations: availableTranslations,
    },
    syncTranslationWithStore,
  );
};

export default setupTranslation;
